import React from 'react'

const facebook = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M21.9266 20.7208C21.9266 21.3868 21.3865 21.9269 20.7205 21.9269H15.1517V13.4641H17.9923L18.4176 10.166H15.1517V8.06025C15.1517 7.10536 15.4168 6.45466 16.7862 6.45466L18.5327 6.45384V3.50401C18.2305 3.46389 17.1938 3.37407 15.9877 3.37407C13.4697 3.37407 11.7458 4.91105 11.7458 7.73371V10.166H8.89795V13.4641H11.7458V21.9269H1.27934C0.61308 21.9269 0.0732422 21.3868 0.0732422 20.7208V1.27956C0.0732422 0.613302 0.61308 0.0733833 1.27934 0.0733833H20.7205C21.3865 0.0733833 21.9266 0.613302 21.9266 1.27956V20.7208Z" fill="currentColor"/>
  </svg>
)

export default facebook
